import React from 'react';
type StepFrameProps = {
  patientId: string;
  /** 1–5: Patient, FSH, Dose, Response, Compare. */
  step: number;
  canNavigate: (step: number) => boolean;
  onNavigate: (step: number) => void;
  footer: React.ReactNode;
  children: React.ReactNode;
};
const STEP_NAMES = ['Patient', 'FSH', 'Starting dose', 'Response', 'Compare'];
export function StepFrame({
  patientId,
  step,
  canNavigate,
  onNavigate,
  footer,
  children
}: StepFrameProps) {
  const total = STEP_NAMES.length;
  return <section className="overflow-hidden rounded-2xl border border-rule bg-white shadow-[0_1px_2px_rgba(28,29,34,0.04),0_8px_24px_-12px_rgba(28,29,34,0.08)]" aria-label={`Patient ${patientId}, step ${step} of ${total}`} data-id="element-349" data-mp="27x1xwdf986rz">
      <header className="flex items-center justify-between border-b border-rule px-5 py-3.5 md:px-8" data-id="element-350" data-mp="1y5e9ymhwp7v9">
        <span className="font-mono text-[11px] tracking-[0.16em] text-ink" data-id="element-351" data-mp="2luqkbpoyzlz5">PATIENT {patientId}</span>
        <span className="flex items-center gap-5" data-id="element-352" data-mp="2qokxsbdzf4ps">
          <ol className="hidden items-center gap-1 md:flex" aria-label="Steps" data-id="element-353" data-mp="1faqhbyqbufde">
            {STEP_NAMES.map((name, i) => {
            const s = i + 1;
            const enabled = s !== step && canNavigate(s);
            return <li key={name} data-id="element-354" data-mp="1p2crdrqxi8ek" data-mpi={i}>
                  <button type="button" disabled={!enabled} onClick={() => onNavigate(s)} aria-current={s === step ? 'step' : undefined} className={`flex items-center gap-2 rounded-full px-2 py-1 text-xs transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent disabled:cursor-default ${s === step ? 'text-ink' : s < step ? 'text-graphite hover:text-ink' : 'text-graphite/40'} ${enabled ? 'hover:bg-wash' : ''}`} data-id="element-355" data-mp="1p2ml9qf3gzpj">
                    <span className={`h-1.5 w-1.5 rounded-full ${s === step ? 'bg-accent' : s < step ? 'bg-ink' : 'bg-rule'}`} data-id="element-356" data-mp="8n34onqokwzz" />
                    {name}
                  </button>
                </li>;
          })}
          </ol>
          <span className="font-mono text-[11px] tracking-[0.16em] text-graphite" data-id="element-357" data-mp="12csnvlzjy9yq">
            STEP {step} / {total}
          </span>
        </span>
      </header>
      <div className="px-5 py-10 md:px-8 lg:px-14 lg:py-12" data-id="element-358" data-mp="1caqdodx28etg">{children}</div>
      <div className="border-t border-rule bg-wash" data-id="element-359" data-mp="1h9jkjnhud7kn">{footer}</div>
    </section>;
}